// extracted by mini-css-extract-plugin
export default {"time":"timeInput_time__mNg8B"};